import { NgModule } from '@angular/core';
import { BrowserModule, BrowserTransferStateModule } from '@angular/platform-browser';
import { HttpClientModule,HTTP_INTERCEPTORS } from '@angular/common/http';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideFirestore, getFirestore} from '@angular/fire/firestore';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideFirebaseApp,initializeApp  } from '@angular/fire/app';
import { provideDatabase, getDatabase } from '@angular/fire/database';
import { getApp } from 'firebase/app'; 
import { environment } from 'src/environments/environment';
import { ClariAuthModule } from './clari-auth/clari-auth.module';
import { AuthTokenInterceptor } from './gen2ai/auth-token.interceptor';
import { ErrorLoggingInterceptor } from './error-logging.interceptor';
import { ShowdownModule } from 'ngx-showdown';
import { showdownMarkdownClassesExtension } from './shared/markdown/showdown-md-classes.extension';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserTransferStateModule,
    HttpClientModule,
    AppRoutingModule,
    SharedModule,
    CoreModule,
    BrowserAnimationsModule,
    ShowdownModule.forRoot({
      flavor: 'github',
      smartIndentationFix: true,
      extensions: [
        showdownMarkdownClassesExtension({
          imageClass: 'md-img',
          textClass: 'md-text',
          aiImageClass: 'ai-image',
          aiImageBucketHint: 'media.geniousvision.com'
        })
      ]
    }),
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    provideFirebaseApp(() => getApp()),
    provideDatabase(() => getDatabase()),
    ClariAuthModule
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorLoggingInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthTokenInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
